import { PorusAdminTruckSearchResponse } from '../../searchTrucks/dtos/porus-admin-truck-search-response';
import { ReviewTrucksTable } from '../views/review-trucks-table';
import { LOCATION_PARSER } from '../../utils/location/index';

export const REVIEW_TRUCK_LIST_TABLE = (
	truckList: Array<PorusAdminTruckSearchResponse> = []
): Array<ReviewTrucksTable> => {
	let results: Array<ReviewTrucksTable> = [];
	if (truckList.length > 0) {
		truckList.map((truck) => {
			let row = {} as ReviewTrucksTable;
			row.destinations = [];

			if (
				truck.destinations != undefined &&
				truck.destinations != null &&
				truck.destinations.length > 0
			) {
				const destination = JSON.parse(truck.destinations);
				destination.map((destination: any) => {
					var location = { city: '', state: '' };
					if (
						destination.city != undefined &&
						destination.city != null &&
						destination.city.length > 0
					) {
						location.city = destination.city;
					}
					if (
						destination.state != undefined &&
						destination.state != null &&
						destination.state.length > 0
					) {
						location.state = destination.state;
					}
					row.destinations.push(location);
				});
			}

			row.id = truck.id;
			row.carrierHubId = truck.carrierHubId;
			row.trailerType = truck.trailerType;
			row.availableDate = truck.availableDate;
			row.availableTime = truck.availableTime;
			row.origin = truck.origin;
			row.originString = LOCATION_PARSER(truck.origin);
			row.carrier = truck.carrier;
			row.contactName = truck.contactName;
			row.contactEmail = truck.contactEmail;
			row.contactPhone = truck.contactPhone;
			row.contactMobile = truck.contactMobile;
			results.push(row);
		});
	}
	return results;
};
